module.exports = __webpack_public_path__ + "static/media/icon-home-tag2.3b8cb5ed.png";